export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-foreground-500 text-sm font-semibold uppercase tracking-widest mb-6 font-label">
            Why ACBuy Spreadsheet?
          </p>
          <h2 className="text-foreground-950 font-heading text-3xl md:text-5xl font-bold leading-[1.3] mb-6">
            The Smarter Way to Source from China
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed font-body">
            ACBuySpreadsheet is not just another shopping tool — it is a complete system built by experienced buyers who understand exactly where the hidden costs live. By organizing every order through our proven spreadsheet framework, you eliminate agent markups, compare real prices across suppliers, and track every single purchase from warehouse to doorstep. Thousands of smart shoppers have already switched from overpaying on traditional agent platforms to the ACBuySpreadsheet method. The result? An average of 30-40% savings on every single China haul, zero confusion about shipping costs, and complete transparency from order to delivery.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="text-foreground-950 font-heading text-3xl md:text-4xl font-bold">30-40%</div>
              <p className="text-foreground-500 text-sm mt-1 font-label">Average Savings</p>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="text-center">
              <div className="text-foreground-950 font-heading text-3xl md:text-4xl font-bold">10K+</div>
              <p className="text-foreground-500 text-sm mt-1 font-label">Active Users</p>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="text-center">
              <div className="text-foreground-950 font-heading text-3xl md:text-4xl font-bold">14</div>
              <p className="text-foreground-500 text-sm mt-1 font-label">Categories</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}